import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Tab } from '@material-ui/core';
import { StyledTabs } from '../../../components/FlowConfigurationInputs';
import Search from '../../../components/Search/Search';
import BotService from '../../../services/BotService/BotService';
import Spinner from '../../../components/Spinner/Spinner';
import info from '../../../assets/icons/info.svg';
import plus from '../../../assets/icons/plus.svg';
import FilterSection from './filters/FilterSection';
import Card from './cards/Card';
import './Market.css';

/**
 * @Description This function lets you return Autom Section component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Market() {
    const { t } = useTranslation();
    const label = 'CONTENT.BOT.';
    const [botArray, setBotArray] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchData, setSearchData] = useState(botArray);
    const [filter, setFilter] = useState({});
    const [anchorElAT, setAnchorElAT] = useState(null); // Automation Type
    const [anchorElBP, setAnchorElBP] = useState(null); // Business Process
    const [anchorElCategory, setAnchorElCategory] = useState(null); // Category
    const [anchorElSS, setAnchorElSS] = useState(null); // Security Stage
    const [anchorElAPP, setAnchorElAPP] = useState(null); // Applications

    useEffect(() => {
        fetchData().then(r => r);
    }, []);

    const fetchData = async () => {
        setLoading(true);
        const response = await BotService.getBotsByFilter(Object.keys(filter).length > 0 && filter, 'global');

        if (response?.status) {
            if (response.data) {
                setBotArray(response.data);
                setSearchData(response.data);
            } else {
                setBotArray([]);
                setSearchData([]);
            }
        } else {
            setBotArray([]);
            setSearchData([]);
        }
        setLoading(false);
    };

    function handleClick(event, setState) {
        setState(event.currentTarget);
    }

    return (
        <div className="variant-container">
            <Search data={botArray} setSearchData={setSearchData} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}
                searchKey={['bot_name', 'bot_tags', 'business_process_name', 'categories_name']}>
                <div style={{ minHeight: 35, marginTop: 'auto', marginBottom: 'auto' }}>
                    <button onClick={(event) => handleClick(event, setAnchorElAT)} className="searchbar-button">
                        {t(label + 'AUTOMATION-TYPE')}
                        <img className="searchbar-button-info" src={info} alt="info" />
                        <img className="searchbar-button-plus" alt="ipaas_market" src={plus} />
                    </button>
                    <button onClick={(event) => handleClick(event, setAnchorElBP)} className="searchbar-button">
                        {t(label + 'BUSINESS-PROCESS')}
                        <img className="searchbar-button-info" src={info} alt="info" />
                        <img className="searchbar-button-plus" alt="ipaas_market" src={plus} />
                    </button>
                    <button onClick={(event) => handleClick(event, setAnchorElCategory)} className="searchbar-button">
                        {t(label + 'CATEGORIES')}
                        <img className="searchbar-button-info" src={info} alt="info" />
                        <img className="searchbar-button-plus" alt="ipaas_market" src={plus} />
                    </button>
                    <button onClick={(event) => handleClick(event, setAnchorElAPP)} className="searchbar-button">
                        {t(label + 'APPLICATION')}
                        <img className="searchbar-button-info" src={info} alt="info" />
                        <img className="searchbar-button-plus" alt="ipaas_market" src={plus} />
                    </button>
                </div>
                <Grid item xs={12} style={{ marginTop: "-10px", marginLeft: 15 }}>
                    <FilterSection botArray={searchData} setSearchData={setSearchData} filter={filter}
                        setFilter={setFilter} setBotArray={setBotArray}
                        anchorElAT={anchorElAT} setAnchorElAT={setAnchorElAT} anchorElBP={anchorElBP}
                        setAnchorElBP={setAnchorElBP} anchorElSS={anchorElSS} anchorElAPP={anchorElAPP}
                        setAnchorElSS={setAnchorElSS} setAnchorElAPP={setAnchorElAPP} type="bot"
                        anchorElCategory={anchorElCategory}
                        setAnchorElCategory={setAnchorElCategory}
                        setLoading={setLoading} />
                </Grid>
            </Search>

            {loading ? <div className="ipaas-loading"><Spinner color="#002742" /></div> : searchData?.length > 0 ?
                <div className="autom-cards">
                    {searchData.map((item, itemI) => <Card key={itemI} bot={item} />)}
                </div>
                :
                <div className='bot-not-found'>
                    <span>{t('CONTENT.BOT.BOTS-NOT-FOUND')}</span>
                </div>
            }
        </div>
    );
}

export default Market;
